import { api } from '../../api.js';
import { config } from '../../config.js';

const actions = {
    BACK_OBTENER_ZONAS_PRECIOS_PARCELAS: function({ commit }, data){
        return new Promise((resolve, reject) =>{
            api.call(config.getAPIRoute('back.obtener.zonas.precios.parcelas'), data).then(res =>{
                resolve(res);
            }).catch(error =>{
                console.log(error);
                reject(error);
            });
        });
    },

    BACK_VINCULAR_PRECIOS_PARCELAS_GUARDAR: function({ commit }, data){
        return new Promise((resolve, reject) =>{
            api.call(config.getAPIRoute('back.vincular.precios.parcelas.guardar'), data).then(res =>{
                resolve(res);
            }).catch(error =>{
                console.log(error);
                reject(error);
            });
        });
    }
}

export default {
    actions
}